import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "purchase-package-service";

export default {
    getPurchasePackages(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/purchase-package/package/list/" + param.page,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getTopPurchasePackages() {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/v1/cms/purchase-package/package/top",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    savePurchasePackage(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/purchase-package/package/add",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    exportPurchasePackages(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/purchase-package/package/export",
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    exportMembers(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/purchase-package/package/card/export",
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getVoucherOptions() {
        return new Promise((resolve, reject) => {
            api.get(
                "voucher-service/v1/cms/voucher/options/vouchers",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getRewardOptions() {
        return new Promise((resolve, reject) => {
            api.get(
                "rewards-service/rewards/merchant/options/for-bundle",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getAppHeader() {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/v1/cms/purchase-package/app/view",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    importCardNos(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/purchase-package/package/card/import",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getMembers(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/purchase-package/package/member/list/" + param.page,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    updateAppHeader(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/purchase-package/app/update",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    viewPurchasePackage(uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/v1/cms/purchase-package/package/view/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    updatePurchasePackage(uuid, param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/purchase-package/package/update/" + uuid,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    deletePurchasePackage(uuid) {
        let param = {
            uuid: uuid
        };
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/purchase-package/package/delete",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    confirmAction(param) {
        return new Promise((resolve, reject) => {
            api.post(
                "merchant-auth-service/action/confirm",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getCardNumbers(uuid) {
        let param = {
            customer_uuid: uuid
        };
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/purchase-package/card/customer",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getPrivilegeCardDetails() {
        return new Promise((resolve, reject) => {
          api.get(
            `${BASE_SERVICE_URL}/v1/cms/privilege-card/settings/details`,
            auth.getHeader()
          )
            .then(response => resolve(response))
            .catch((status, error) => reject(status, error));
        });
    },
    savePrivilegeCardSettings(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${BASE_SERVICE_URL}/v1/cms/privilege-card/settings/save`,
                payload,
                auth.getHeader()
            )
                .then(response => resolve(response))
                .catch((status, error) => reject(status, error));
        });
    }
};
